import { render, staticRenderFns } from "./SentNotifications.vue?vue&type=template&id=a494ea78&"
import script from "./SentNotifications.vue?vue&type=script&lang=js&"
export * from "./SentNotifications.vue?vue&type=script&lang=js&"
import style0 from "./SentNotifications.vue?vue&type=style&index=0&id=a494ea78&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports